import {Component} from '@angular/core';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-toelichtingen-tekst',
  templateUrl: './toelichtingen-tekst.component.html',
  styleUrls: ['./toelichtingen-tekst.component.scss'],
})
export class ToelichtingenTekstComponent {}
